export default "__VITE_ASSET__tbQyfBNh__"